import "./EditionResume.css";
import { MDBContainer } from "mdb-react-ui-kit";
import React, { useContext, useEffect, useState } from "react";
import ResumePdfControls from "../../components/edition-resume-pdf/ResumePdfControls";
import ResumePdfDownloadModal from "../../components/edition-resume-pdf/ResumePdfDownloadModal";
import ResumePdfPreviewBlob from "../../components/edition-resume-pdf/ResumePdfPreviewBlob";
import ResumePdfShareModal from "../../components/edition-resume-pdf/ResumePdfShareModal";
import ResumePreview from "../../components/edition-resume-preview/ResumePreview";
import BusinessSkillsSection from "../../components/edition-resume/BusinessSkillsSection";
import DiplomasSection from "../../components/edition-resume/DiplomasSection";
import ExperiencesSection from "../../components/edition-resume/ExperiencesSection";
import HobbiesSection from "../../components/edition-resume/HobbiesSection";
import LanguageSkillsSection from "../../components/edition-resume/LanguageSkillsSection";
import LogoSelection from "../../components/edition-resume/logo/LogoSelection";
import TopLeftSection from "../../components/edition-resume/TopLeftSection";
import TopRightSection from "../../components/edition-resume/TopRightSection";
import { ResumeContext } from "../../context/resume/resume-context";
import { useCurrentUserRoles } from "../../hooks/useCurrentUserRoles";

export function EditionResume() {
    const [ backgroundImage ] = useState( "/bg/compliance.webp" );
    const { isLoading } = useContext( ResumeContext );
    const { isClientRole } = useCurrentUserRoles();

    useEffect( () => {
        document.body.classList.add( 'edition-resume-open' );

        return () => document.body.classList.remove( 'edition-resume-open' );
    }, [] );

    if ( isLoading ) {
        return <div className="text-light p-5">Chargement du CV...</div>;
    }

    return (
        <MDBContainer
            fluid
            className="fond-accueil edition-resume-page"
            style={ {
                backgroundImage: `url(${ backgroundImage })`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            } }
        >
            <div className="row py-5 justify-content-around animation-fade-in edition-resume-row">
                <div className={ `col-md-6 px-5 scrollable-col ${ isClientRole ? 'hide-for-client' : '' }` }>
                    <TopLeftSection/>
                    <div className="d-flex flex-column justify-content-center mt-3 gap-2">
                        <LanguageSkillsSection/>
                        <BusinessSkillsSection/>
                        <ExperiencesSection/>
                        <DiplomasSection/>
                        <HobbiesSection/>
                    </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 cv-preview-container px-5 scrollable-col preview-scroll-column">
                    <LogoSelection/>
                    <TopRightSection/>
                    <ResumePdfControls/>
                    <ResumePreview/>
                </div>
            </div>
            <ResumePdfPreviewBlob/>
            <ResumePdfDownloadModal/>
            <ResumePdfShareModal/>
        </MDBContainer>
    );
}
